import React from 'react';
import './Partners.css';

const Partners = () => {
  const partners = [
    {
      id: 1,
      name: 'HUAWEI',
      logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/e/e8/Huawei_Logo.svg/2560px-Huawei_Logo.svg.png',
      description: 'Tập đoàn công nghệ hàng đầu thế giới - Đối tác chiến lược toàn diện',
      highlight: 'HUAWEI x GNINE SOLAR: KÝ KẾT CHIẾN LƯỢC HỢP TÁC TẠI "VIETNAM INSTALLER SUMMIT 2025"',
      content: 'Ngày 27/9/2025, tại Hội thảo "Vietnam Installer Summit 2025", Gnine Solar và tập đoàn công nghệ hàng đầu thế giới Huawei đã chính thức ký kết hợp tác chiến lược toàn diện. Sự kiện này không chỉ là dấu mốc quan trọng đối với Gnine mà còn là bước tiến lớn, mang giải pháp đầu tư điện mặt trời tiên tiến nhất của thế giới đến gần hơn với người tiêu dùng Việt Nam.',
      featured: true
    },
    {
      id: 2,
      name: 'GROWATT',
      logo: 'https://en.growatt.com/Content/images/logo.png',
      description: 'Thương hiệu toàn cầu hàng đầu về giải pháp năng lượng phân tán',
      content: 'Growatt là thương hiệu toàn cầu hàng đầu về giải pháp năng lượng phân tán, chuyên nghiên cứu và sản xuất biến tần năng lượng mặt trời.',
      featured: false
    },
    {
      id: 3,
      name: 'JA SOLAR',
      logo: 'https://www.jasolar.com/uploadfile/image/JA-logo.png',
      description: 'Thương hiệu pin năng lượng mặt trời hiệu suất cao hàng đầu',
      content: 'JA Solar là một thương hiệu chuyên về sản xuất pin năng lượng mặt trời hiệu suất cao, có mặt tại hơn 170 quốc gia và khu vực.',
      featured: false
    },
    {
      id: 4,
      name: 'EVN FINANCE',
      logo: 'https://evnfc.vn/images/logo.png',
      description: 'Đối tác tài chính hỗ trợ trả góp lên đến 80%',
      content: 'EVN Finance đồng hành cùng Gnine Solar mang đến giải pháp tài chính linh hoạt, hỗ trợ trả góp lên đến 80% trong 60 tháng.',
      featured: false
    }
  ];

  const featuredPartner = partners.find(p => p.featured);
  const otherPartners = partners.filter(p => !p.featured);

  return (
    // <section id="partners" className="partners-section">
    //   <div className="container">
    //     <div className="section-header" data-aos="fade-up">
    //       <span className="section-tag">ĐỐI TÁC</span>
    //       <h2 className="section-title">ĐỐI TÁC TIÊU BIỂU</h2>
    //       <p className="section-subtitle">
    //         Hợp tác cùng các thương hiệu hàng đầu thế giới mang đến giải pháp năng lượng tối ưu
    //       </p>
    //     </div>

    //     {/* Featured Partner */}
    //     {featuredPartner && (
    //       <div className="featured-partner" data-aos="fade-up">
    //         <div className="row align-items-center">
    //           <div className="col-lg-5">
    //             <div className="partner-logo-wrapper">
    //               <img
    //                 src={featuredPartner.logo}
    //                 alt={featuredPartner.name}
    //                 className="partner-logo-large"
    //               />
    //             </div>
    //           </div>
    //           <div className="col-lg-7">
    //             <div className="partner-info">
    //               <span className="partner-badge">Đối tác chiến lược</span>
    //               <h3 className="partner-highlight">{featuredPartner.highlight}</h3>
    //               <p className="partner-content">{featuredPartner.content}</p>
    //               <a href="#contact" className="btn btn-primary">
    //                 Tìm hiểu thêm
    //                 <i className="fas fa-arrow-right ms-2"></i>
    //               </a>
    //             </div>
    //           </div>
    //         </div>
    //       </div>
    //     )}

    //     {/* Other Partners */}
    //     <div className="partners-grid">
    //       {otherPartners.map((partner, index) => (
    //         <div
    //           key={partner.id}
    //           className="partner-card"
    //           data-aos="fade-up"
    //           data-aos-delay={index * 100}
    //         >
    //           <div className="partner-card-header">
    //             <img
    //               src={partner.logo}
    //               alt={partner.name}
    //               className="partner-logo"
    //             />
    //           </div>
    //           <div className="partner-card-body">
    //             <h4 className="partner-name">{partner.name}</h4>
    //             <p className="partner-description">{partner.description}</p>
    //             <p className="partner-text">{partner.content}</p>
    //           </div>
    //           <div className="partner-card-footer">
    //             <a href="#contact" className="partner-link">
    //               Xem hợp tác
    //               <i className="fas fa-chevron-right ms-2"></i>
    //             </a>
    //           </div>
    //         </div>
    //       ))}
    //     </div>

    //     {/* Partners Logo Slider */}
    //     <div className="partners-logos" data-aos="fade-up">
    //       <div className="logos-wrapper">
    //         <div className="logo-item">
    //           <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/e/e8/Huawei_Logo.svg/2560px-Huawei_Logo.svg.png" alt="Huawei" />
    //         </div>
    //         <div className="logo-item">
    //           <img src="https://en.growatt.com/Content/images/logo.png" alt="Growatt" />
    //         </div>
    //         <div className="logo-item">
    //           <img src="https://www.jasolar.com/uploadfile/image/JA-logo.png" alt="JA Solar" />
    //         </div>
    //         <div className="logo-item">
    //           <img src="https://evnfc.vn/images/logo.png" alt="EVN Finance" />
    //         </div>
    //         <div className="logo-item">
    //           <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/e/e8/Huawei_Logo.svg/2560px-Huawei_Logo.svg.png" alt="Huawei" />
    //         </div>
    //         <div className="logo-item">
    //           <img src="https://en.growatt.com/Content/images/logo.png" alt="Growatt" />
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </section>
    //
    <div></div>
  );
};

export default Partners;
